import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'

import useForm from '../../hooks/useForm'

import image from '../../assets/imgs/background/wall.jpg'

import style from '../../assets/styles/auth/authStyle.module.css'
import formStyle from '../../assets/styles/formStyle.module.css'
import { validarCamposNuevoUsuario } from '../../helpers/db-validators/validacionNuevoUsuario'
import { changeColorCoding } from '../../helpers/db-validators/colorCoding'
import apiUsuarios from '../../services/apis/apiUsuarios'
import { types } from '../../types/types'
import dbConnection from '../../services/utilities/dbConnection'
import { AuthContext } from '../../auth/AuthContext'
import { useHistory } from 'react-router-dom'


const SignupScreen = () => {

    const { values, handleInputChange } = useForm({
        nombre: '',
        apellidos: '',
        correo: '',
        password: ''
    })

    const { nombre, apellidos, correo, password } = values;
    const [ mensajeError, setMensajeError ] = useState('');
    const { dispatch } = useContext( AuthContext );
    const history = useHistory();

    const handleSignUp = async(e) => {
        e.preventDefault();
        changeColorCoding([]);
        setMensajeError('');
        
        const errores = validarCamposNuevoUsuario(values);

        if ( errores.length > 0 ) {
            return changeColorCoding( errores )
        }

        try {
            const crearUsuario = await apiUsuarios.post( values );

            if ( !crearUsuario.ok ) {
                if ( crearUsuario.errores ){
                    changeColorCoding( crearUsuario.errores )
                } else {
                    setMensajeError( crearUsuario.msg )
                }
                return;
            }
            
            // Exito
            const { token, usuario } = crearUsuario.response.data;
            localStorage.setItem( 'token_organizador', token );
            dbConnection.defaults.headers.common['x-token'] = token;
            dispatch({ type: types.login, payload: usuario });
            history.replace(`/organizador/${ usuario._id }`)

        } catch (error) {
            console.log(error)
        }
        


    }

    return (
        <div className={ style.authScreen + ' wrap-reverse' }>

            <div className={ style.signupImageSection }>
                <img src={image} alt="" />
            </div>

            <div className={ style.signupBox }>
                <h1> Roof Sales </h1>
                <p> ¡Bienvenido! Ingresa tus datos para unirte a nuestra comunidad</p>
                <form className={ formStyle.form }>

                    <div className={ formStyle.formGroup }>
                        <label htmlFor="nombre" > Nombre(s) </label>
                        <input
                            name='nombre'
                            value={ nombre }
                            onChange={ handleInputChange }
                            type="text" />

                        <div data-error='nombre'></div>
                    </div>


                    <div className={ formStyle.formGroup }>
                        <label htmlFor="apellidos" >Apellidos</label>
                        <input
                            name='apellidos'
                            value={ apellidos }
                            onChange={ handleInputChange }
                            type="text" />
                        <div data-error='apellidos'></div>
                    </div>

                    <div className={ formStyle.formGroup} >
                        <label htmlFor="correo" > Correo Electrónico</label>
                        <input
                            name='correo'
                            value={ correo }
                            onChange={ handleInputChange }
                            autoComplete='off'
                            type="email" />
                        <div data-error='correo'></div>
                    </div>

                    <div className={ formStyle.formGroup } >
                        <label htmlFor="password" > Contraseña</label>
                        <input
                            name='password'
                            value={ password }
                            onChange={ handleInputChange }
                            autoComplete="off"
                            type="password" />
                        <div data-error='password' ></div>
                    </div>

                    { mensajeError && 
                        <div className='mensajeError' >
                            <p> {mensajeError} </p>
                        </div> 
                    }

                    <button 
                        onClick={ handleSignUp }
                        className={ `btn activo bg-primary mb-1` } >
                        Registrarse
                    </button>
                </form>



                <p className='text-align-center'>
                    ¿Ya tienes una cuenta?
                    <Link to='/login' >
                        Inicia sesión mejor
                    </Link> <br />
                </p>
            </div>


        </div>
    )
}

export default SignupScreen